import { createStore } from 'vuex'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { login as loginApi, register as registerApi, getUserInfo as getUserInfoApi, logout as logoutApi } from '@/api/user'

export default createStore({
  state: {
    token: getToken() || '',
    userInfo: {},
    tenantInfo: {},
    dynamicRoutesLoaded: false,
    cryptoEnabled: false,
    rsaPublicKey: ''
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_TENANT_INFO(state, tenantInfo) {
      state.tenantInfo = tenantInfo
    },
    SET_DYNAMIC_ROUTES_LOADED(state, loaded) {
      state.dynamicRoutesLoaded = loaded
    },
    SET_CRYPTO_ENABLED(state, enabled) {
      state.cryptoEnabled = enabled
    },
    SET_RSA_PUBLIC_KEY(state, key) {
      state.rsaPublicKey = key
    }
  },
  actions: {
    async login({ commit }, loginData) {
      try {
        const res = await loginApi(loginData)
        const token = res.data
        commit('SET_TOKEN', token)
        setToken(token)
        return res
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async register({ commit }, registerData) {
      try {
        const res = await registerApi(registerData)
        return res
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getUserInfo({ commit }) {
      try {
        const res = await getUserInfoApi()
        const userInfo = res.data
        commit('SET_USER_INFO', userInfo)
        return res
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async logout({ commit }) {
      try {
        await logoutApi()
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', {})
        commit('SET_DYNAMIC_ROUTES_LOADED', false)
        removeToken()
      } catch (error) {
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', {})
        commit('SET_DYNAMIC_ROUTES_LOADED', false)
        removeToken()
        return Promise.reject(error)
      }
    },
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
      setToken(token)
    },
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },
    setTenantInfo({ commit }, tenantInfo) {
      commit('SET_TENANT_INFO', tenantInfo)
    },
    setCryptoEnabled({ commit }, enabled) {
      commit('SET_CRYPTO_ENABLED', enabled)
    },
    setRsaPublicKey({ commit }, key) {
      commit('SET_RSA_PUBLIC_KEY', key)
    }
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    tenantInfo: state => state.tenantInfo,
    dynamicRoutesLoaded: state => state.dynamicRoutesLoaded,
    cryptoEnabled: state => state.cryptoEnabled,
    rsaPublicKey: state => state.rsaPublicKey
  }
})
